export const gymTypes = [
    { label: "Franchisee", value: "Franchisee" },
    { label: "Company Owned", value: "Company Owned" },
    { label: "Corporate", value: "Corporate" },
    { label: "3P", value: "3P" }
];